import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import InfoPage from "./Infopage";
import { Helmet } from "react-helmet-async";
// TODO: replace with your real answers.
const FAQS = [
  {
    cat: "Orders",
    q: "How do I track my order?",
    a: "We send a notification with a tracking link once your order ships. You can also contact us with your order number.",
  },
  {
    cat: "Orders",
    q: "Can I change or cancel my order?",
    a: "Yes, if it hasn't shipped yet. Contact us as soon as possible with your order number.",
  },
  {
    cat: "Shipping",
    q: "How long does delivery take?",
    a: "Standard delivery takes 2–4 business days. See the Shipping page for all options.",
  },
  {
    cat: "Shipping",
    q: "Do you deliver internationally?",
    a: "We ship to selected countries. Duties and taxes are set by your country.",
  },
  {
    cat: "Returns",
    q: "What is your returns policy?",
    a: "You can return most unused items within 7 days of delivery. See the Returns page for details.",
  },
  {
    cat: "Returns",
    q: "When will I get my refund?",
    a: "Within 7 business days of us receiving your return, to your store credit.",
  },
  {
    cat: "Payments",
    q: "Which payment methods do you accept?",
    a: "We accept  mobile money. All payments are processed securely.",
  },
  {
    cat: "Payments",
    q: "Is my payment information safe?",
    a: "Yes. We never store your full card details.",
  },
];

const CATS = ["All", ...new Set(FAQS.map((f) => f.cat))];

function FAQs() {
  const [cat, setCat] = useState("All");
  const [open, setOpen] = useState(null);
  const list = cat === "All" ? FAQS : FAQS.filter((f) => f.cat === cat);

  return (
    <InfoPage
      title="Frequently asked questions"
      intro="Quick answers about orders, delivery, returns and payments."
    >
      <Helmet>
        <title>FAQs | Ninety One Clothing Store in Nairobi, Kenya</title>
        <meta
          name="description"
          content="Answers to common questions about ordering, delivery in Nairobi and across Kenya, returns, refunds and M-Pesa payments at Ninety One."
        />
        <link rel="canonical" href="https://ninetyone.co.ke/faqs" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQS.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: f.a,
              },
            })),
          })}
        </script>
      </Helmet>

      <div className="info-chips" role="tablist" aria-label="FAQ categories">
        {CATS.map((c) => (
          <button
            key={c}
            role="tab"
            aria-selected={cat === c}
            className={`info-chip ${cat === c ? "info-chip--active" : ""}`}
            onClick={() => {
              setCat(c);
              setOpen(null);
            }}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="info-accordion">
        {list.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={f.q} className="info-acc-item">
              <h3 className="info-acc-heading">
                <button
                  className="info-acc-btn"
                  aria-expanded={isOpen}
                  aria-controls={`faq-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                >
                  <span>{f.q}</span>
                  <Plus
                    className={`info-acc-icon ${isOpen ? "info-acc-icon--open" : ""}`}
                    aria-hidden="true"
                  />
                </button>
              </h3>
              {isOpen && (
                <p id={`faq-${i}`} className="info-acc-panel">
                  {f.a}
                </p>
              )}
            </div>
          );
        })}
      </div>

      <p className="info-text info-center">
        Can't find your answer?{" "}
        <Link to="/contact-us" className="info-link">
          Contact us
        </Link>
        .
      </p>
    </InfoPage>
  );
}

export default FAQs;
